import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { Layout } from "../components/Layout";
import { BuyCard } from "../components/BuyCard";
import { api } from "../lib/api";

export default function RooftopTradeQueue() {
  const { rooftop_id } = useParams();
  const [rooftop, setRooftop] = useState(null);
  const [trades, setTrades] = useState([]);

  const load = useCallback(async () => {
    const [r, t] = await Promise.all([
      api.get(`/rooftops/${rooftop_id}`),
      api.get(`/trade-queue/${rooftop_id}`),
    ]);
    setRooftop(r.data); setTrades(t.data);
  }, [rooftop_id]);

  useEffect(() => { load(); }, [load]);

  return (
    <Layout variant="rooftop" rooftopId={rooftop_id} rooftopName={rooftop?.name}>
      <div className="mb-6">
        <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">Trade desk</div>
        <h1 className="text-3xl font-bold text-navy">Trade queue</h1>
        <p className="text-sm text-slate-500 mt-1 font-medium">Pending appraisals from the desk · system ACV + justification · approve, counter, or pass.</p>
      </div>

      <div className="space-y-3" data-testid="trade-queue-list">
        {trades.length === 0 && (
          <div className="bg-white border border-slate-200 rounded-xl p-10 text-center text-sm text-slate-500">
            Trade desk is clear. Next appraisal drops in when it hits the desk.
          </div>
        )}
        {trades.map((v) => <BuyCard key={v.vin} vehicle={v} onAction={load} />)}
      </div>
    </Layout>
  );
}
